import { FreightHandlingUnitRowSchema } from "@redotech/redo-fulfillment-common/freight/freight-handling-unit";
import * as z from "zod";

export const getFreightHandlingUnits = {
  name: "getFreightHandlingUnits" as const,
  input: z.object({}),
  output: z.object({ handlingUnits: z.array(FreightHandlingUnitRowSchema) }),
};
